import { connect } from 'react-redux';
import { Actions as PAYMENTACTIONS } from '../../store/actions/paymentActions';
import { Fragment, useEffect, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { ShoppingCartIcon } from '@heroicons/react/24/outline';
import Select from 'react-select';
import {
  Link,
} from "react-router-dom";

const PaymentConfirmationModal = ({
    setPurchaseConfirmationModalOpen,
    purchaseConfirmationModalOpen,
    selectedServiceId,
    getPurchasedServices,
    service,
    course,
    purchaseService,
    organisations,
    profile
}) => {

    const [organisation, setOrganisation] = useState({});

    useEffect(() => {
        if (profile && profile.email) {
            getPurchasedServices();
        }
    }, [profile && profile.email]);

    useEffect(() => {
        if (organisations && course){
            const org = organisations.find(o => o.creditBalance >= course.credits)
            console.log('org',org)
            setOrganisation(org)
        }
    }, [course,organisations])

    const confirmPurchase = () => {
        purchaseService(selectedServiceId,organisation.value)
        setPurchaseConfirmationModalOpen(false);
    }

    return (
        <Transition.Root show={purchaseConfirmationModalOpen} as={Fragment}>
            <Dialog as="div" className="fixed z-10 inset-0 overflow-y-auto" onClose={() => setPurchaseConfirmationModalOpen(false)}>
                <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                        &#8203;
                    </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div className="inline-block align-bottom bg-white rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                <div className="sm:flex sm:items-start">
                                    <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
                                        <ShoppingCartIcon className="h-6 w-6 text-green-600" aria-hidden="true" />
                                    </div>
                                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                        <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                                            Confirm
                                        </Dialog.Title>
                                        <div className="mt-2">
                                            <p className="text-sm text-gray-500">
                                                { course &&
                                                    <>{course.credits} Credits will be used to give you access to {course.name}. <br/> <span className="text-xs">This action only provides course access to yourself.</span></>
                                                }
                                                { service &&
                                                    `${service.credits} Credits to gain access to ${service.name}`
                                                }
                                            </p>
                                            { profile && 
                                                <div className="mt-2">
                                                  <label className="text-xs text-gray-500">
                                                    Use Credits from
                                                  </label>
                                                  <div className="rounded-md shadow-sm">

                                                    <Select
                                                      styles={{control: base => ({ ...base, border:0, boxShadow: "none"})}}
                                                      components={{
                                                        IndicatorSeparator: () => null
                                                      }}
                                                      className="w-full text-sm"
                                                      defaultValue={organisation}
                                                      name="frequency"
                                                      selected={organisation}
                                                      onChange={(val) => setOrganisation(val)}
                                                      options={organisations}
                                                    />
                                                  </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                                {
                                    !profile &&
                                    <div>
                                        <Link
                                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-orange-600 text-base font-medium text-white hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 sm:ml-3 sm:w-auto sm:text-sm"
                                            to="/"
                                        >
                                            Create an Account
                                        </Link>
                                        <span className="ml-2 text-center text-sm leading-5 text-gray-600 max-w">
                                            or 
                                            <Link 
                                                to="/login"
                                                className="ml-1 font-medium text-orange-600 hover:text-orange-500 focus:outline-none focus:underline transition ease-in-out duration-150"
                                                > 
                                                Login
                                            </Link>
                                        </span>
                                    </div>
                                }
                                {
                                    organisation && course && organisation.creditBalance < course.credits &&
                                    <button
                                        type="button"
                                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-orange-600 text-base font-medium text-white hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 sm:ml-3 sm:w-auto sm:text-sm"
                                        onClick={() => confirmPurchase()}
                                    >
                                        Insufficient Credits.
                                    </button>
                                }
                                {
                                    organisation && course && organisation.creditBalance >= course.credits &&
                                    <button
                                        type="button"
                                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-orange-600 text-base font-medium text-white hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 sm:ml-3 sm:w-auto sm:text-sm"
                                        onClick={() => confirmPurchase()}
                                    >
                                        Yes, let's start.
                                    </button>
                                }
                                { profile && 
                                    <button
                                        type="button"
                                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                        onClick={() => setPurchaseConfirmationModalOpen(false)}
                                    >
                                        No, go back.
                                    </button>
                                }
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    )
}

const mapStateToProps = (state, ownProps) => {

    const selectedServiceId = state.payment && state.payment.selectedServiceId

    const course = state.courses && state.courses.find(c => c.id == selectedServiceId)
    const service = state.services && state.services.find(c => c.id == selectedServiceId)

    const organisations = state?.my?.organisations?.filter?.(o => o.demo != "yes")?.map(o => ({
        label: `${o.name} - ${o.creditBalance} Credits`,
        value: o.id,
        creditBalance: o.creditBalance,
    }))

    const profile = state?.my?.profile || localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))


    return {
        purchaseConfirmationModalOpen: state.payment.purchaseConfirmationModalOpen,
        selectedServiceId,
        organisations,
        course,
        service,
        profile
    }
}

const mapDispatchToProps = dispatch => ({
    purchaseService: (serviceId,orgId) => dispatch(PAYMENTACTIONS.purchaseService(serviceId,orgId)),
    getPurchasedServices: () => dispatch(PAYMENTACTIONS.getPurchasedServices()),
    setPurchaseConfirmationModalOpen: (modalOpen) => dispatch(PAYMENTACTIONS.setPurchaseConfirmationModalOpen(modalOpen))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentConfirmationModal)